import DeclineResourcesView from './DeclineResources.view';
export default DeclineResourcesView;
